export default __webpack_public_path__ + "static/media/new_improvvisazione_funzionale.8c251d16.jpeg";